import { IconButton, TableCell } from '@material-ui/core';
import { Icon, iconType } from '@sensenet/icons-react';
import React, { Component } from 'react';
export const styles = {
  actionMenuButton: {
    padding: 0,
    width: 30,
    cursor: 'pointer'
  },
  icon: {
    verticalAlign: 'middle',
    opacity: 0
  },
  selectedIcon: {
    verticalAlign: 'middle'
  },
  hoveredIcon: {
    verticalAlign: 'middle'
  },
  virtual: {
    height: '57px',
    width: '100%',
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
};
export class ActionsCell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorLeft: 0,
      anchorTop: 0
    };
    this.handleActionMenuClick = this.handleActionMenuClick.bind(this);
  }
  handleActionMenuClick(e) {
    this.props.openActionMenu(e);
  }
  render() {
    return /*#__PURE__*/React.createElement(TableCell, {
      component: this.props.virtual ? 'div' : 'td',
      style: this.props.virtual ? {
        ...styles.actionMenuButton,
        ...styles.virtual
      } : styles.actionMenuButton
    }, /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": "Menu",
      "aria-owns": "actionmenu",
      onClick: event => this.handleActionMenuClick(event)
    }, /*#__PURE__*/React.createElement(Icon, {
      type: iconType.materialui,
      iconName: "more_vert"
    })));
  }
}
//# sourceMappingURL=ActionsCell.js.map